<template>
 <div>
  <malfunction ref="carViolation">
    <el-button
      type="primary"
      @click="addCarViolation"
      size="small"
      v-if="isShowAddBtn && judgePermission('vehicle_violation_record_list_create')"
    >新增违章</el-button>
  </malfunction>
  <!-- 新增违章记录 -->
  <AddViolation
    :loading="oLoading"
    :plateNo="plateNo"
    :carId="carId"
    v-model="violationShow"
    @refresh="refreshViolation"
  />
 </div>
</template>
<script>
import malfunction from './malfunction.vue'
import AddViolation from '@/pages/carsService/violation/components/addViolation.vue'

export default {
  components: {
    malfunction,
    AddViolation,
  },
  props: {
    isShowAddBtn: {
      type: Boolean,
      default: false,
    },
    plateNo: {
      type: [String, Number],
      default: '',
    },
    carId: {
      type: [String, Number],
      default: '',
    },
  },
  data() {
    return {
      violationShow: false,
      oLoading: {
        search: false,
      },
    }
  },
  methods: {
    // 新增违章
    addCarViolation() {
      this.violationShow = true
    },
    // 刷新违章列表
    refreshViolation() {
      this.$refs.carViolation.doSearch()
    },
  },
}
</script>
